import enLocale from 'element-ui/lib/locale/lang/en'
import enJson from  './en.json'
const en = {
	...enJson,
	...enLocale
}
export default en
